// The reason that saving the avatar from the web builder failed. Value is sent from the client.
export enum SaveFailureReasonEnum {
  // An Unlockable fashion item being saved is no longer available.
  ITEM_UNAVAILABLE = 'item_unavailable',
}
